
import React from 'react'
import Hero from '../components/HomePage/Hero'
import Features from '../components/HomePage/Features'
import FeatureBanner from '../components/HomePage/FeatureBanner'
import TrustedBy from '../components/HomePage/TrustedBy'
import HelixEcosystem from '../components/HomePage/HelixEcosystem'
import Community from '../components/HomePage/Community'
import BuildWithHelix from '../components/HomePage/BuildWithHelix'
import Faq from '../components/HomePage/Faq'

const HomePage = () => {
  return (
    <div className='w-full flex flex-col'>
      <Hero/>
      <Features/>
      <FeatureBanner/>
      <TrustedBy/>
      <HelixEcosystem/>
      <Community/>
      <BuildWithHelix/>
      <Faq/>
    </div>
  )
}

export default HomePage